module.exports = __webpack_public_path__ + "static/media/Principal-House.39ede612.png";